import { z } from 'zod'
import { IdentificationCardSchema } from '../../domains/identification'
import { LastNameSchema } from '../../domains/last-name'
import { NameSchema } from '../../domains/name'
import { PlaceSchema } from '../../domains/place'
import { PartnerPepSchema, PersonPepSchema, RelativePepSchema } from '../../entities/client/pep'
import { optionalString, requiredString } from '../../primitives'

/**
 * Integración del órgano superior del cliente jurídico: miembros del Consejo de
 * Administración / Junta Directiva / Administrador Único o similar. Espejo del FEIC
 * interno (form-members-board): identidad + documento + lugar de nacimiento + cargo +
 * si es extranjero + la declaración PEP COMPLETA de cada miembro (misma forma que la
 * sección PEP del titular).
 */

/** Declaración PEP embebida por miembro (idéntica a la sección PEP del titular). */
const PepFields = z.object({
  isPep: z.boolean().default(false),
  pep: z.array(PersonPepSchema).default([]),
  hasRelativesPep: z.boolean().default(false),
  relativesPep: z.array(RelativePepSchema).default([]),
  hasPartnersPep: z.boolean().default(false),
  partnersPep: z.array(PartnerPepSchema).default([]),
  isCPE: z.boolean().default(false)
})

/** Miembro del órgano superior / junta directiva. */
export const BoardMemberSchema = z
  .object({
    id: optionalString(),
    name: NameSchema,
    lastName: LastNameSchema,
    identificationCard: IdentificationCardSchema,
    birthplace: PlaceSchema,
    position: requiredString(), // cargo que ocupa
    foreign: z.boolean()
  })
  .merge(PepFields)

export type BoardMember = z.infer<typeof BoardMemberSchema>
